import { render, staticRenderFns } from "./MonthSpending.vue?vue&type=template&id=6edcb836&scoped=true&"
import script from "./MonthSpending.vue?vue&type=script&lang=js&"
export * from "./MonthSpending.vue?vue&type=script&lang=js&"
import style0 from "./MonthSpending.vue?vue&type=style&index=0&id=6edcb836&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edcb836",
  null
  
)

export default component.exports